
import _ from "underscore";
import { updateObject } from "../storeUtils";

import * as actionTypes from '../actions/actionTypes'

const initialState = {
    isLoading: false,
    loaderMessage: undefined,
    error: {},
};

export const loaderReducer = (state = initialState, action = { type: "" }) => {
    switch (action.type) {
        case actionTypes.SHOW_LOADER:
            return updateObject(state, { isLoading: true, loaderMessage: action.payload });
        case actionTypes.HIDE_LOADER:
            return updateObject(state, { isLoading: false });
        case actionTypes.SHOW_ERROR:
            const { error, variant, icon } = action.payload;
            let updateError = {};
            if (!_.isEmpty(error))
                updateError = { errorTxt: error, variant, icon };
            return updateObject(state, { error: updateError });
        case actionTypes.HIDE_ERROR:
            return updateObject(state, { error: {} });
        default:
            return state;
    }
};
